import _ from "lodash";
import { ExportFormatTypeEnum, IAvailableNotificationInfoDTO, IEditReportDeliveryDTO, IEditReportScheduleDTO, IEditReportTaskDTO, ReportDeliveryType, ReportTypeEnum, devInfoEmail, hiddenRecipients } from "../../services/reporting-data-service/ReportScheduleModels";
// import { FieldNamesMarkedBoolean } from "react-hook-form";
import { DateRangeType } from "../../common/enums/DRCXEnums";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import i18n from "../../services/localization-service/i18n";
import { IReferenceNotificationListDTO } from "../../services/setpoint-administration-service/Models";
import { NotificationListsFormType } from "../form-notification-lists/FormNotificationListsUtils";
import { FormRadioGroupRadioButton } from "../forms/form-radio-group/FormRadioGroup";
import { VirtualizedListItem } from "../virtualized-list/VirtualizedList";
import Enumerable from "linq";
import { FieldIsDirtyType } from "../../common/utility-types/FieldIsDirtyType";



export enum ScheduledReportsAdminMode {
    Add = 0,
    Edit = 1
}

export enum StepEnum {
    Properties = 1,
    Notifications = 2,
    Summary = 3
}

export type ReportScheduleFormType = {

    frequencyOption: DateRangeType,
    expanded: boolean;

} & IEditReportScheduleDTO;



export type ReportScheduleRecipientType = {
    id: number;
    address: string;
    organizationID: number;
    selected: boolean;
} & VirtualizedListItem

export type ScheduledReportsFormType = {

    id: number;
    name: string;
    reportConfigID: number;
    exportFormat: ExportFormatTypeEnum;
    reportType: ReportTypeEnum;

    organizationID: number;
    //overrideGroupID: number;
    overrideTatID: number;
    timezoneIndex: number;
    description: string;

    recipients: ReportScheduleRecipientType[];
    schedules: ReportScheduleFormType[];
    isMyReports?: boolean;
    isAdminView?: boolean;

} & NotificationListsFormType;

export type ReportScheduleRecipientDirtyType = FieldIsDirtyType<ReportScheduleRecipientType>;
// export type ReportScheduleRecipientDirtyType = {

//     selected?: boolean;
// }

export type ReportScheduleNotificationListDirtyType = FieldIsDirtyType<IReferenceNotificationListDTO>;
// export type ReportScheduleNotificationListDirtyType = {
//     selected?: boolean;
// }

export type ReportScheduleFormDirtyType = FieldIsDirtyType<ReportScheduleFormType>;
// export type ReportScheduleFormDirtyType = {

//     description?: boolean;
//     repeatRange?: boolean;
//     repeatInterval?: boolean;
//     timezoneIndex?: boolean;
//     startTime?: boolean;
//     endTime?: boolean;
//     isActive?: boolean;
//     dayOfMonth?: boolean;
//     dayOfWeek?: boolean;
//     hour?: boolean;
//     minute?: boolean;

// }
export type ScheduleReportsFormDirtyType = FieldIsDirtyType<ScheduledReportsFormType>;
// export type ScheduleReportsFormDirtyType = {

//     reportConfigID?: boolean;
//     exportFormat?: boolean;
//     reportType?: boolean;
//     timezoneIndex?: boolean;
//     description?: boolean;
//     schedules: ReportScheduleFormDirtyType[];
//     recipients: ReportScheduleRecipientDirtyType[];
//     notificationLists: ReportScheduleNotificationListDirtyType[];


// }

export const daysOfWeek: string[] = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thrusday',
    'Friday',
    'Saturday'
]

export const reportTypeRadioButtons: FormRadioGroupRadioButton[] = [{
    label: i18n.t('scheduledReports.reportTypeOptions.custom'),
    ariaLabel: i18n.t('scheduledReports.reportTypeOptions.custom') as string,
    value: ReportTypeEnum.Custom
}, {
    label: i18n.t('scheduledReports.reportTypeOptions.groupMarketing'),
    ariaLabel: i18n.t('scheduledReports.reportTypeOptions.groupMarketing') as string,
    value: ReportTypeEnum.GroupMarketing    
}, {
    label: i18n.t('scheduledReports.reportTypeOptions.user'),
    ariaLabel: i18n.t('scheduledReports.reportTypeOptions.user') as string,
    value: ReportTypeEnum.User    
}];


export const exportOptionRadioButtons: FormRadioGroupRadioButton[] = [{
    label: i18n.t('scheduledReports.exportOptions.excel'),
    ariaLabel: i18n.t('scheduledReports.exportOptions.excel') as string,
    value: ExportFormatTypeEnum.Excel2007
}, {
    label: i18n.t('scheduledReports.exportOptions.pdf'),
    ariaLabel: i18n.t('scheduledReports.exportOptions.pdf') as string,
    value: ExportFormatTypeEnum.Pdf
}, {
    label: i18n.t('scheduledReports.exportOptions.csv'),
    ariaLabel: i18n.t('scheduledReports.exportOptions.csv') as string,
    value: ExportFormatTypeEnum.Csv
}, {
    label: i18n.t('scheduledReports.exportOptions.other'),
    ariaLabel: i18n.t('scheduledReports.exportOptions.other') as string,
    value: ExportFormatTypeEnum.Other

}];


export const defaultScheduledReportTask: ScheduledReportsFormType = {
    id: -1,
    name: '',
    reportConfigID: -1,
    exportFormat: ExportFormatTypeEnum.Csv,
    reportType: ReportTypeEnum.Custom,
    organizationID: -1,
        overrideTatID: -1,
    timezoneIndex: 20,
    description: '',
    recipients: [],
    notificationLists: [],
    schedules: [],
}

function mapFormScheduleToModel(formSchedule: ReportScheduleFormType): IEditReportScheduleDTO {

    const model: IEditReportScheduleDTO = _.cloneDeep(formSchedule);

    if (formSchedule.frequencyOption === DateRangeType.Raw) {

        model.isCustom = true;
    }

    model.startTime?.setMonth(new Date().getMonth());

    return model;
}

function mapFormNotificationListToModel(formValue: IReferenceNotificationListDTO,
    referenceData: IAvailableNotificationInfoDTO): IEditReportDeliveryDTO {

    return {
        id: formValue.id,
        address: referenceData.notificationLists.find(o => o.dt === formValue.name)?.id?.toString() ?? '',
        deliveryType: ReportDeliveryType.NotificationList,
        selected: formValue.selected
    } as IEditReportDeliveryDTO
}

function mapFormRecipientToModel(formValue: ReportScheduleRecipientType ): IEditReportDeliveryDTO {

    return {
        id: formValue.id,
        address: formValue.address,
        deliveryType: ReportDeliveryType.Email,
        selected: formValue.selected
    } as IEditReportDeliveryDTO
}

const ScheduledReportsEditorUtils = {
    mapToModel: (contextGroupID: number,
        form: ScheduledReportsFormType, 
        originalModel: IEditReportTaskDTO,
        referenceData: IAvailableNotificationInfoDTO,
        myReports: boolean): IEditReportTaskDTO => {

        const model: IEditReportTaskDTO = {

            id: form.id,
            name: form.name,
            reportConfigId: form.reportType !== ReportTypeEnum.GroupMarketing ? form.reportConfigID : undefined,
            exportFormat: form.exportFormat,
            reportType: form.reportType,
            organizationId: form.organizationID,
            overrideGroupId: originalModel.overrideGroupId,
            overrideTatId: form.reportType !== ReportTypeEnum.GroupMarketing ? undefined : form.overrideTatID,
            timezoneIndex: form.timezoneIndex,
            description: form.description,
            deliveries: [],
            schedules: [],
            isMyReports: form.isMyReports,
            isAdminView: form.isAdminView
        };

        const scheduleModels = form.schedules.map(o => mapFormScheduleToModel(o));
       
        if ((model.id ?? 0) < 0) {
            scheduleModels.forEach(o => o.id = -1);
        }

        // include all new schedules
        model.schedules = scheduleModels.filter(o => o.id < 0);
        model.schedules?.forEach(o => o.isModified = true);

        if ((model.id ?? 0) > 0) {
            originalModel.schedules?.forEach(o => {

                const item = scheduleModels.find(v => v.id === o.id);
                if (item) {
                    // found an existing schedule, determine if it has been modified
                    if (!_.isEqual(o, item)) {
                        item.isModified = true;
                    }
                    model.schedules?.push(item);
                } else {
                    const copy: IEditReportScheduleDTO = {...o,
                        isDeleted: true
                    };
                    model.schedules?.push(copy);
                }
            });
        }

        const originalNotificationLists = originalModel.deliveries?.filter(o => o.deliveryType === ReportDeliveryType.NotificationList) ?? [];        
        const notificationLists = form.notificationLists.map(o => mapFormNotificationListToModel(o, referenceData));

        const notificationListIDs = Enumerable.from(notificationLists).select(o => o.id ?? 0);
        let min = notificationListIDs.length ? Enumerable.from(notificationListIDs).select(o => o ?? 0).min() : 0;
        if (min > 0) {
            min = 0;
        }
        --min;
        
        notificationLists.filter(o => o.selected && (o.id ?? 0) > 0).forEach(o => {

            const original = originalNotificationLists.find(v => v.address === o.address);
            if (!original) {
                o.id = min--;
            }
        });

        // include all newly selected notification lists
        model.deliveries = notificationLists.filter(o => o.selected && (o.id ?? 0) < 0);
        model.deliveries?.forEach(o => o.isModified = true);

        if ((model.id ?? 0) > 0) {

            originalModel.deliveries?.filter(o => o.deliveryType === ReportDeliveryType.NotificationList).forEach(o => {

                const item = notificationLists.find(v => v.address?.toLowerCase() === o.address?.toLowerCase());
                if (item) {
                    if (!item.selected) {
                        const copy: IEditReportDeliveryDTO = {...o,
                            isDeleted: true
                        };
                        
                        model.deliveries?.push(copy);
                    } else {
                        const copy: IEditReportDeliveryDTO = {...o};
                        model.deliveries?.push(copy);
                    }
                }
            });
        }

        const recipients = form.recipients.map(o => mapFormRecipientToModel(o));

        // include all newly selected recipients
        const recipientsToAdd = recipients.filter(o => o.selected && (o.id ?? 0) < 0);
        recipientsToAdd.forEach(o => o.isModified = true);
        model.deliveries = model.deliveries.concat(recipientsToAdd);

        if ((model.id ?? 0) > 0) {

            originalModel.deliveries?.filter(o => o.deliveryType === ReportDeliveryType.Email).forEach(o => {

                const item = recipients.find(v => v.address?.toLowerCase() === o.address?.toLowerCase());
                if (item) {
                    if (!item.selected) {
                        const copy: IEditReportDeliveryDTO = {...o,
                            isDeleted: true
                        };
                        
                        model.deliveries?.push(copy);
                    } else {
                        const copy: IEditReportDeliveryDTO = {...o};
                        model.deliveries?.push(copy);
                    }
                }
            });
        }

        if ((!myReports || (model.id ?? -1) < 0) && !model.deliveries?.find(o => o.address === devInfoEmail)) {
            model.deliveries.push({
                id: -1,
                address: devInfoEmail,
                deliveryType: ReportDeliveryType.Email,
                isModified: true
            } as IEditReportDeliveryDTO)
        }

        if (form.reportType === ReportTypeEnum.GroupMarketing) {
            model.overrideGroupId = contextGroupID;
        }

        return model;
    },
    mapToFormValues: (model: IEditReportTaskDTO, 
        referenceData: IAvailableNotificationInfoDTO,
        eLynxAdmin: boolean,
        copy: boolean,
        myReports: boolean,
        userID: number
    ): ScheduledReportsFormType  => {


        const formValues: ScheduledReportsFormType = {


            id: model.id ?? -1,
            name: model.name ?? '',

        
            reportConfigID: model.reportConfigId ?? -1,
            exportFormat: model.exportFormat !== ExportFormatTypeEnum.Csv && 
                            model.exportFormat !== ExportFormatTypeEnum.Pdf &&
                            model.exportFormat !== ExportFormatTypeEnum.Excel &&
                            model.exportFormat !== ExportFormatTypeEnum.Custom ? ExportFormatTypeEnum.Other :
                            model.exportFormat,
            reportType: model.reportType,
        
        
            organizationID: model.organizationId ?? -1,
            //overrideGroupID: model.overrideGroupId ?? -1,
            overrideTatID: model.overrideTatId ?? -1,
            timezoneIndex: model.timezoneIndex ?? 20,
            description: model.description ?? '',
        
            recipients: [],
            notificationLists: [],
            schedules: model.schedules ? 
                            _.cloneDeep(model.schedules).map(o => {
                                return {...o,
                                frequencyOption: (o.repeatInterval ?? 1) > 1 ? DateRangeType.Raw : o.repeatRange,
                                startTime: o.startTime ? new Date(o.startTime) : new Date(),
                                expanded: o.id < 0 || model.schedules?.length === 1
                            } as ReportScheduleFormType
                            }) : 
                            [],
            isMyReports: model.isMyReports,
            isAdminView: model.isAdminView,
        };


        let nextID = -1;
        if (!myReports) {
            referenceData.notificationLists.forEach(o => {

                    const existing = model.deliveries?.filter(v => v.deliveryType === ReportDeliveryType.NotificationList)
                                            .find(z => z.address === o.id.toString())

                    formValues.notificationLists.push({
                        id: existing ? o.id : nextID--,
                        name: o.dt,
                        organizationID: o.oid,
                        selected: existing !== undefined ? true : false
                    } as IReferenceNotificationListDTO); 
            });

            nextID = -1;
        }

        const recipients = !myReports ? referenceData.recipients
            .filter(o => o.tid === RecipientTypeEnum.Email && (!hiddenRecipients.find(v => v === o.dt) || eLynxAdmin))
            .map(o => {
                const recipient: ReportScheduleRecipientType = {
                    //id: o.id,
                    id: nextID--,
                    address: o.dt,
                    organizationID: o.oid,
                    selected: false
                };
                return recipient;
            }) :
            referenceData.recipients
            .filter(o => o.tid === RecipientTypeEnum.Email && o.uid === userID)
            .map(o => {
                const recipient: ReportScheduleRecipientType = {
                    //id: o.id,
                    id: nextID--,
                    address: o.dt,
                    organizationID: o.oid,
                    selected: false
                };
                return recipient;
            });

        model.deliveries?.filter(o => o.deliveryType === ReportDeliveryType.Email && (!hiddenRecipients.find(v => v === o.address) || eLynxAdmin))
        .forEach(o => {

            const item = recipients.find(v => v.address === o.address);
            if (item) {
                item.id = o.id as number;
                item.selected = true;
            } else if (!myReports) {
                const recipient: ReportScheduleRecipientType = {
                    //id: -1,
                    id: o.id as number,
                    address: o.address as string,
                    organizationID: -1,
                    selected: true
                };
                recipients.push(recipient);

            }
        });

        formValues.recipients = recipients.sort((a, b) => a.address.toLowerCase().localeCompare(b.address.toLowerCase()));

        if (copy) {
            formValues.id = -1;
            formValues.name += ' (Copy)';

            formValues.recipients.forEach(o => o.selected = false);
            formValues.notificationLists.forEach(o => o.selected = false);

            const devEmail = formValues.recipients.find(o => o.address === devInfoEmail);
            if (devEmail) {
                devEmail.selected = true;
            }
        }

        return formValues;
    },
    getNewFormSchedule: function(nextID: number, 
        timezoneIndex: number, 
        currentSchedules: ReportScheduleFormType[]
        ): ReportScheduleFormType {

        const now = new Date();

        let description = i18n.t("scheduledReports.newSchedule", {num: Math.abs(nextID)}) as string;

        if (currentSchedules.find(o => o.description?.toLowerCase() === description.toLowerCase())) {
            description += ` - ${Math.abs(nextID)}`;
        }

        return {
            id: nextID,
            description: description,
            timezoneIndex: timezoneIndex,
            repeatRange: DateRangeType.Month,
            repeatInterval: 1,
            lastRunTime: undefined,
            dayOfMonth: now.getDate(),
            dayOfWeek: now.getDay(),
            hour: now.getHours(),
            minute: now.getMinutes(),
            isActive: true,
            startTime: now,
            expanded: true,
            frequencyOption: DateRangeType.Month
        } as ReportScheduleFormType
    },
    formIsDirty: function(dirtyFields?: ScheduleReportsFormDirtyType): boolean {

        const scheduleIsDirty = (item?: ReportScheduleFormDirtyType) => {

            return (item?.description === true ||
        
                item?.repeatRange === true ||
                item?.repeatInterval === true ||
                item?.timezoneIndex === true ||
                item?.startTime === true ||
                item?.endTime === true ||
                item?.isActive === true ||
                item?.dayOfMonth === true ||
                item?.dayOfWeek === true ||
                item?.hour === true ||
                item?.minute === true);
        };

        const recipientIsDirty = (item?: ReportScheduleRecipientDirtyType) => {
            return item?.selected;
        };

        const notificationListIsDirty = (item?: ReportScheduleNotificationListDirtyType) => {
            return item?.selected;
        };
        
        return (dirtyFields?.reportConfigID === true ||
            dirtyFields?.exportFormat === true ||
            dirtyFields?.reportType === true ||
            dirtyFields?.description === true ||
            (dirtyFields?.schedules?.some(o => scheduleIsDirty(o)) ?? false) ||
            (dirtyFields?.recipients?.some(o => recipientIsDirty(o)) ?? false) ||
            (dirtyFields?.notificationLists?.some(o => notificationListIsDirty(o)) ?? false));

    }
}

export default ScheduledReportsEditorUtils;
